var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container-fluid",attrs:{"id":"nav-bar"}},[_c('b-navbar',{attrs:{"toggleable":"lg"}},[_c('b-collapse',{attrs:{"id":"nav-collapse","is-nav":""}},[_c('nav-link')],1)],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }